import { render, staticRenderFns } from "./DataGrid.vue?vue&type=template&id=5b22dd41&scoped=true&"
import script from "./DataGrid.ts?vue&type=script&lang=ts&"
export * from "./DataGrid.ts?vue&type=script&lang=ts&"
import style0 from "./DataGrid.vue?vue&type=style&index=0&id=5b22dd41&prod&lang=less&scoped=true&"
import style1 from "./DataGrid.vue?vue&type=style&index=1&id=5b22dd41&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b22dd41",
  null
  
)

export default component.exports